/* 武將檔常用的小工具。都是在「呼叫的當下」才去拿模擬核心的函式，所以武將檔可以比核心早載入。 */
import { SG } from './sg.ts';
import type { Unit, SigMarks } from '../heroes/types.ts';
export { SG };
export type Vec = [number, number];
export const K = 0.7; // 縱深壓縮（同 SG.K）
export const L = (v: number | number[] | undefined, lv: number): number => SG.L(v, lv); // 依等級取值
export const gd = (ax: number, ay: number, bx: number, by: number): number => SG.gd(ax, ay, bx, by); // 地面距離
export const along = (x: number, y: number, dir: Vec, d: number): Vec => SG.along(x, y, dir, d); // 沿方向走一段
export const move = (u: Unit, dx: number, dy: number): void => SG._sim.move(u, dx, dy); // 推動單位（會被地形擋）
export const landing = (x0: number, y0: number, x1: number, y1: number): Vec => SG._sim.landing(x0, y0, x1, y1); // 沿直線找最遠可落腳點
export const spMul = (u: Unit): number => SG.spMul(u); // 技能傷害倍率（技能傷害% × v0.3.0 屬性成長）
export const sigOf = (u: Unit, name: string): SigMarks[string] | null => (u.sg ? u.sg[name] : null); // 學會的被動標記 { sk, lv, i, v(key) }
// 衝到 t 身邊（陳到護駕、曹洪獻馬）（每 0.03 秒走一段，穿過樹林），到了呼叫 done；t 跑掉或死掉就停在原地（卡在樹林裡就推到最近的空地）
export function dashTo(w: any, u: Unit, t: Unit, speed: number, done: (t: Unit) => void): void {
  const M = SG.MAP, settle = () => { u.air = false; if (!M.walkable(u.x, u.y, M.BODY)) [u.x, u.y] = M.nearestFree(u.x, u.y); };
  const step = () => {
    if (!u.alive) return;
    if (!t.alive) { settle(); return; }
    const d = gd(u.x, u.y, t.x, t.y), reach = u.r + t.r + 6;
    if (d <= reach + speed * 0.03) {
      const q = landing(t.x, t.y, t.x - Math.sign(t.x - u.x || 1) * reach, t.y); // 從對方腳下往這一側找落腳點
      u.x = q[0]; u.y = q[1]; u.f = Math.sign(t.x - u.x) || u.f; settle(); done(t); return;
    }
    const dir = SG.dirTo(u, t.x, t.y); u.x += dir[0] * speed * 0.03; u.y += dir[1] * speed * 0.03 * SG.K; u.air = true;
    w.later(0.03, step);
  };
  step();
}
